import { useState } from 'react';
import { HelpTip, PanelHowTo, RATINGS, api } from './_barrel.js';


        // Tenant-wide "what changed since yesterday" — the morning-triage digest
        // on the Operations screen. Reads /api/v1/dashboard/whats-new (fetched by
        // the parent). Each row opens that subject's record.
        function WhatsNewPanel({ whatsNew, setView, setSelectedSubject }) {
            const [open, setOpen] = useState(true);
            const items = (whatsNew && whatsNew.items) || [];
            const hours = (whatsNew && whatsNew.window_hours) || 24;
            const openSubject = (id) => { setSelectedSubject(id); setView('subject-detail'); };
            const chip = (n, label, colour) => n > 0 ? (
                <span className="text-xs font-mono" style={{ padding: '2px 8px', borderRadius: '999px', border: `1px solid ${colour}`, color: colour }}>
                    {n} {label}
                </span>
            ) : null;
            return (
                <div className="panel" style={{ borderLeft: '3px solid var(--gold)' }}>
                    <div className="panel-header is-self-collapse flex justify-between items-center cursor-pointer" onClick={() => setOpen(!open)}>
                        <div className="font-display">What changed since yesterday
                            {items.length > 0 && (
                                <span style={{ marginLeft: '8px', padding: '1px 6px', border: '1px solid var(--rule-2)', background: 'var(--zone-3)', color: 'var(--text-muted)', fontWeight: 400 }}>{items.length}</span>
                            )}
                            <HelpTip text="Everything that entered the system across all your subjects in the window — new incidents, breach hits, sanctions matches, hostile mentions and Companies House changes. The subjects with the most serious new activity sort first. Click a row to open that record." />
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="font-mono" style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--text-muted)' }}>last {hours}h</div>
                            <div className="text-xs text-muted">{open ? '▾' : '▸'}</div>
                        </div>
                    </div>
                    <PanelHowTo id="whats_new" />
                    {open && (
                        items.length === 0 ? (
                            <div className="px-6 py-5 text-sm" style={{ color: 'var(--green)' }}>
                                All quiet — nothing new across your subjects in the last {hours}h.
                            </div>
                        ) : (
                            <div>
                                {items.map(it => {
                                    const otherMentions = Math.max(0, (it.new_mentions || 0) - (it.new_hostile || 0));
                                    return (
                                        <div key={it.subject_id} className="table-row px-6 py-3 cursor-pointer" onClick={() => openSubject(it.subject_id)}>
                                            <div className="flex justify-between items-start gap-4">
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex items-center gap-2 flex-wrap">
                                                        <span className="font-display text-base" style={{ color: 'var(--gold)' }}>{it.subject_name}</span>
                                                        {it.risk_band && (
                                                            <span className="font-mono text-xs uppercase tracking-widest" style={{ color: RATINGS.hex(it.risk_band) }}>
                                                                {it.risk_band}{it.composite != null ? ` · ${Number(it.composite).toFixed(1)}` : ''}
                                                            </span>
                                                        )}
                                                    </div>
                                                    {it.headline && <div className="text-xs text-muted font-mono mt-1 truncate">{it.headline}</div>}
                                                </div>
                                                <div className="flex flex-wrap gap-2 justify-end" style={{ maxWidth: '54%' }}>
                                                    {chip(it.new_sanctions, 'sanctions', 'var(--red)')}
                                                    {chip(it.new_breaches, 'breach', 'var(--red)')}
                                                    {chip(it.new_hostile, 'hostile', 'var(--amber)')}
                                                    {chip(it.new_incidents, 'incident', 'var(--gold)')}
                                                    {chip(it.new_appointments, 'CH', 'var(--text-muted)')}
                                                    {chip(otherMentions, 'mention', 'var(--text-muted)')}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )
                    )}
                </div>
            );
        }

export { WhatsNewPanel };
